<template>
  <div class="text-center onboarding-banner">
    <div class="inner-wrapper">
      <div class="logo-wrapper">
        <i class="logo-round-icon"></i>
      </div>
      <div class="message bold mb-4 pb-3">
        Magical things happen when inspired people work toward a shared goal
      </div>
      <div class="title text-large mb-4 bold">
        How would you like to start?
      </div>
      <add-goal-actions class="mb-3" :expand-goal-on-creation-page="true" :org-id="orgId" />
      <b-button
        @click="$emit('dismiss')"
        variant="link"
        class="text-normal-1 text-primary bold d-block mx-auto"
        pill
        >Dismiss</b-button
      >
    </div>
  </div>
</template>

<script>
import AddGoalActions from '@/components/goal/AddGoalActions.vue'
import { BButton } from 'bootstrap-vue'

/**
 * This component shows the onboarding banner.
 * It contains a link, click of which triggers app onboarding tour
 */
export default {
  name: 'OnboardingBanner',
  props: ['orgId'],
  components: {
    BButton,
    AddGoalActions
  },
  data() {
    return {
      showOnboardingTour: true
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
$sidePadding: 50px;
$logoDimension: 65px;
.message {
  font-size: 2rem;
}
.logo-wrapper {
  transform: translateY(-($sidePadding + $logoDimension / 2) + $sidePadding);
}
.logo-round-icon {
  @include dimension($logoDimension, $logoDimension);
}
.inner-wrapper {
  max-width: 415px;
  margin: 0 auto;
}
.onboarding-banner {
  box-shadow: $deepShadow;
  border-radius: 10px;
  padding: 0 $sidePadding $sidePadding $sidePadding;
  max-width: 750px;
}
.tour-btn {
  width: 275px;
}
@include media-breakpoint-up(md) {
  .onboarding-banner {
    width: 750px;
  }
}
</style>
